<template>
	<div class='knd-videos m-t-md m-b-md'>
		<swiper
			:slidesPerView="1.4" 
			:breakpoints='{
			"640": {
				"slidesPerView": 1.4,
				"spaceBetween": 40
			},
			"768": {
				"slidesPerView": 2.2,
				"spaceBetween": 100
			},
			"1024": {
				"slidesPerView": 3,
				"spaceBetween": 100
				}
			}'
			:centeredSlides="true" 
			:space-between="20"
			navigation
			:grabCursor="true"
			:pagination='{
				"dynamicBullets": true
			}'
			@swiper="onSwiper"
			@slideChange="onSlideChange"
			class='knd-swiper'
		>
		<swiper-slide 
				v-for="(article, index) in articles" 
				:key="index +'-article'"
			>
			<article 
				class='knd-article' 
				:class="{'knd-article-even': index % 2 === 0}"
				:style="{'background': '#' + article.thema[0].kleur }"
			>
				<div class='knd-article-header'>
					<div class='knd-article--image' v-if="article.image[0]" @click="showModal(article)">
						<picture >
							<source media="(max-width: 799px)" 
								:srcset="base_url + article.image[0].mobile_url"
							>
							<source 
								media="(min-width: 800px)" 
								:srcset="base_url + article.image[0].url"
							>
							<img 
								:srcset="base_url + article.image[0].url" alt=""
							>
						</picture>

						<div class='knd-article--video-icon'>
							<img src='../assets/svg/play-btn.svg' />
						</div>
					</div>
				</div>

				<div class='knd-article-body'>
					<div class='knd-article--label m-b-sm'>
						{{article.label}}
					</div>

					<div class='knd-article--title'>
						<h2><a :href="article.url" target="_blank">{{article.titel}}</a></h2>
					</div>
				</div>

			</article>
		</swiper-slide>
		</swiper>
	</div>
</template>

<script>
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import SwiperCore, { Navigation, Pagination } from 'swiper';

	import "swiper/swiper-bundle.min.css";

	SwiperCore.use([Navigation, Pagination]);

	export default {
		name: 'Videos',
		components: {      
			Swiper,
			SwiperSlide,
		},
		data() {
			return {
				selected: undefined,
				swiper: undefined,
				base_url: process.env.VUE_APP_IMAGE_URL,
				indexOrder: {}
			};
		},
		mounted: function() {
			let order = [];

			this.$store.state.videos.forEach((d, index) => {
				let hasIndex = order.includes(d.index);

				if(!hasIndex) {
					order.push(d.index);
					this.indexOrder[d.index] = index;
				}
			})
		},

		computed: {
			articles () {
				return this.$store.state.videos;
			}
		},
		watch: {
			'$store.state.selected': function(val, oldVal){
				if(!this.indexOrder[val.index]  === undefined) return;
				
				this.swiper.slideTo(this.indexOrder[val.index]);
			}
		},
		methods: {
			onSwiper(swiper) {
				this.swiper = swiper;
			},
			onSlideChange() {
			}
		}
	}
</script>